'use strict';

var _ = require('lodash');
var Vuex = require('vuex');

module.exports = {
  template: require('./template.html'),
  props: ['item'],
  methods: _.extend({}, Vuex.mapActions([
    'editTartan',
    'viewTartan',
    'downloadItem',
    'toggleFavorites'
  ]))
};



//////////////////
// WEBPACK FOOTER
// ./src/scripts/application/components/application-area/explorer/list-item/index.js
// module id = 161
// module chunks = 0